import React from 'react'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import KeyboardDoubleArrowLeft from '@mui/icons-material/KeyboardDoubleArrowLeft'
import KeyboardDoubleArrowRight from '@mui/icons-material/KeyboardDoubleArrowRight'
import LoadingSpinner from './LoadingSpinner'

const btnStyle = (disabled) => ({
    position: 'relative',
    background: 'var(--dark-gray)',
    border: '1px solid transparent',
    color: 'var(--text-light)',
    padding: '8px',
    borderRadius: 'var(--radius-sm)',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontSize: 'var(--text-sm)',
    minWidth: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: disabled ? 0.5 : 1
})

const iconStyle = { fontSize: '14px', fill: 'url(#goldGradient)' }

const rangeTextStyle = {
    fontSize: 'var(--text-sm)',
    fontWeight: '600',
    margin: '0 var(--spacing-xs)',
    whiteSpace: 'nowrap',
    minWidth: '80px',
    textAlign: 'center',
    display: 'inline-block',
    background: 'var(--gradient-orange)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
}

/** Общая мобильная пагинация (first / prev / range / next / last). */
export default function MobilePaginationActions({
    page,
    rowsPerPage,
    count,
    onPageChange,
    loadingButton,
    pageAction = false
}) {
    const safePage = isNaN(page) ? 0 : page
    const safeRowsPerPage = isNaN(rowsPerPage) ? 10 : rowsPerPage
    const safeCount = isNaN(count) ? 0 : count

    const totalPages = safeRowsPerPage === 0 ? 0 : Math.ceil(safeCount / safeRowsPerPage)

    const goTo = (newPage, action) => {
        if (pageAction) {
            onPageChange(null, newPage, action)
        } else {
            onPageChange(null, newPage)
        }
    }

    const handleFirstPage = () => goTo(0, 'first')
    const handlePrevPage = () => goTo(Math.max(0, safePage - 1), 'prev')
    const handleNextPage = () => goTo(Math.min(totalPages - 1, safePage + 1), 'next')
    const handleLastPage = () => goTo(Math.max(0, totalPages - 1), 'last')

    const isFirstDisabled = safePage === 0 || loadingButton
    const isLastDisabled = safePage >= totalPages - 1 || loadingButton

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--spacing-xs)',
            flexWrap: 'wrap',
            justifyContent: 'center'
        }}>
            <button
                type="button"
                className="gold-gradient-border"
                style={btnStyle(isFirstDisabled)}
                onClick={handleFirstPage}
                disabled={isFirstDisabled}
            >
                {loadingButton === 'first' ? <LoadingSpinner /> : <KeyboardDoubleArrowLeft style={iconStyle} />}
            </button>

            <button
                type="button"
                className="gold-gradient-border"
                style={btnStyle(isFirstDisabled)}
                onClick={handlePrevPage}
                disabled={isFirstDisabled}
            >
                {loadingButton === 'prev' ? <LoadingSpinner /> : <KeyboardArrowLeft style={iconStyle} />}
            </button>

            <span style={rangeTextStyle}>
                {isNaN(page) ? 0 : page * rowsPerPage + 1}-{Math.min((page + 1) * rowsPerPage, safeCount)} of {safeCount}
            </span>

            <button
                type="button"
                className="gold-gradient-border"
                style={btnStyle(isLastDisabled)}
                onClick={handleNextPage}
                disabled={isLastDisabled}
            >
                {loadingButton === 'next' ? <LoadingSpinner /> : <KeyboardArrowRight style={iconStyle} />}
            </button>

            <button
                type="button"
                className="gold-gradient-border"
                style={btnStyle(isLastDisabled)}
                onClick={handleLastPage}
                disabled={isLastDisabled}
            >
                {loadingButton === 'last' ? <LoadingSpinner /> : <KeyboardDoubleArrowRight style={iconStyle} />}
            </button>
        </div>
    )
}
